var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _path0, _circle3, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 366.34 366.34",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#845161;}.cls-3{fill:#69303a;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:none;stroke:#00214e;stroke-miterlimit:10;}.cls-7{fill:#ff2609;}.cls-8{fill:#ffffff;}.cls-9{fill:#00214e;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 87.92,
    y1: 169,
    x2: 257.77,
    y2: 169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6878b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 58.45,
    y1: 317.63,
    x2: 265.95,
    y2: 260.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#315676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1b9e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 112.17,
    y1: 74.28,
    x2: 211.94,
    y2: 115.88,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboards_Diversity_Avatars_by_Netguru") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.17,286.72c-10.65,1.33-20.37,4.17-31.25,4.83-8.19.5-16.4-.43-24.58-1.14a470.21,470.21,0,0,0-53.61-1.59c-9.72.27-19.31,2.64-29.08,2.1-5.15-.28-8-1.59-12.34-4-1.52-.85-15.56-7.49-15.39-6.78.68,2.79,7.28-125.76,9.63-148.16,1.9-18.09,5.88-36.31,14.34-52.54C120.19,63.49,134.8,55,151.83,50.1c25.24-7.23,54.29-4.37,76.24,10.6,16,10.9,25.18,36.72,27.32,56C259,149.41,258.4,260.8,254.17,286.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.41,281.72a184.56,184.56,0,0,1-226.48-1l48.66-22.81a47.68,47.68,0,0,0,4.35-2.34l1.12-.7c.4-.25.79-.51,1.18-.78a46.54,46.54,0,0,0,14.67-16.47c4-7.55,5.32-15.89,5.38-24.39,0-5.72-.31-11.44-.37-17.17q-.06-4.76-.1-9.51l2,1,5.2,2.69,30.29,5.15,31.12,5.3.94,32,.47,15.87,11.47,4.67,9,3.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.15,225.15a60.08,60.08,0,0,1-30.07-2.35C162.5,215.55,148,198.06,146.6,180l5.2,2.69,30.29,5.15,31.12,5.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.41,281.72a184.56,184.56,0,0,1-226.48-1l48.66-22.81a47.68,47.68,0,0,0,4.35-2.34c23.68,17.41,56.64,28.75,85.06,16,8.06-3.62,15.33-10,18.29-18.31l9,3.64Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 119.82,
    cy: 154.54,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 125.82,
    cy: 152.54,
    r: 17
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.36,128.8c11.74,40.68-13.2,89.87-28.54,89.87-21,0-72-16.78-83.73-57.46S127,80.29,158,71.34,223.61,88.11,235.36,128.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.62,78.88a77.34,77.34,0,0,1-4.45,10.59c-6.7,13.54-18.56,23.91-30.52,32.73-9.17,6.76-19,13.13-30.18,15.45-10.15,2.12-27.26.12-33-10.08-6.63-11.67,8-26.39,14.67-34.16,6.3-7.29,14.83-18.43,24.73-20.87.17,0,58-23,58-23,.46,6.9,2.43,13.71,2.36,20.65A30.3,30.3,0,0,1,200.62,78.88Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.4,130.7c-.05.24,5.54,15.88,8.93,25.32a5.25,5.25,0,0,1-4.94,7h-3.64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.86,120.48a31.13,31.13,0,0,1,22.85-2.15"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.75,124.18a36.75,36.75,0,0,1,31.23-1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.3,157.29a3.37,3.37,0,0,0-3,3.15,2.65,2.65,0,0,0,3.24,2.5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 195.78,
    cy: 114.76,
    r: 4.02
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.41,174.33a1.86,1.86,0,0,1,2.68-.5c2.08,1.46,5.88,4.56,11.28,5.63,7.36,1.47,13.75-1.48,15.27.42.86,1.07-.19,2.37-2.2,4.05a19.74,19.74,0,0,1-14.86,3.69c-7.08-1.33-12.4-9.53-12.4-12.44A1.68,1.68,0,0,1,172.41,174.33Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M170.55,134.05c6.1-.07,6.28,9.26.18,9.43h-.27c-6.1.07-6.28-9.25-.18-9.42h.27Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M220.79,132.42c5.66-.07,5.83,8.58.17,8.74h-.26c-5.66.06-5.83-8.59-.16-8.75h.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar4);
export default __webpack_public_path__ + "static/media/avatar4.44b24aa07d3a4951cd09024f20c11655.svg";
export { ForwardRef as ReactComponent };